import ApiFetcher3 from '../ApiFetcher3';

class UserAttributesApi {
  static get() {
    return ApiFetcher3.get('user/attributes/', {shape: 'generic'});
  }
}

export default UserAttributesApi;
